import React from 'react';
import dayjs from 'dayjs';
import EyeIcon from '@mui/icons-material/RemoveRedEye';
import { DateTimeFormatProps } from './props';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useDateTimeFormat } from './hook';

dayjs.extend(relativeTime);
dayjs.locale('es');

const DateTimeFormat = ({ dateAt }: DateTimeFormatProps) => {
    const { isRelative, toggleFormat } = useDateTimeFormat();

    const handleClick = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        e.stopPropagation();
        toggleFormat();
    };
    return (
        <>
            <EyeIcon
                sx={{
                    marginRight: '10px',
                    cursor: 'pointer',
                    color: 'primary.main',
                }}
                onClick={handleClick}
            />
            {isRelative
                ? dayjs(dateAt).subtract(5, 'hours').fromNow()
                : dayjs(dateAt)
                    .subtract(5, 'hours')
                    .format('DD-MM-YYYY HH:mm:ss')}
        </>
    );
};

export default DateTimeFormat;
